(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ffh-catalogue"]) return;
  try {
    
document.querySelectorAll('[data-pd]').forEach(root=>{
 const main=root.querySelector('.pd-main-image'),allThumbs=[...root.querySelectorAll('[data-pd-image]')],box=root.querySelector('dialog'),zoom=box.querySelector('img');let thumbs=allThumbs.filter(t=>!t.hidden);const filterGallery=(side)=>{allThumbs.forEach(t=>t.hidden=!!(side&&t.dataset.gallerySide&&t.dataset.gallerySide!==side));thumbs=allThumbs.filter(t=>!t.hidden)};let index=Math.max(0,thumbs.findIndex(t=>new URL(t.dataset.pdImage,location.href).pathname===new URL(main.src,location.href).pathname));
 const displayImage=(src)=>{const sized=(width)=>{const u=new URL(src,location.href);u.searchParams.set('width',String(width));return u.href};main.sizes='(max-width: 760px) calc(100vw - 64px), (max-width: 1512px) 45vw, 680px';main.srcset=[360,540,750,1100,1500].map(w=>sized(w)+' '+w+'w').join(', ');main.src=sized(750);zoom.dataset.zoomSrc=src;if(box.open)zoom.src=src;};
 const show=(i)=>{index=(i+thumbs.length)%thumbs.length;const src=thumbs[index].dataset.pdImage;displayImage(src);thumbs.forEach((t,n)=>t.setAttribute('aria-current',String(n===index)));box.querySelector('.pd-counter').textContent=`${index+1} / ${thumbs.length}`;};
 allThumbs.forEach(t=>t.addEventListener('click',()=>show(thumbs.indexOf(t))));
 root.querySelector('.pd-open').addEventListener('click',()=>{show(index);zoom.src=zoom.dataset.zoomSrc;box.showModal()});box.querySelector('.pd-close').addEventListener('click',()=>box.close());box.querySelector('.pd-next').addEventListener('click',()=>show(index+1));box.querySelector('.pd-prev').addEventListener('click',()=>show(index-1));box.addEventListener('keydown',e=>{if(e.key==='ArrowRight')show(index+1);if(e.key==='ArrowLeft')show(index-1)});box.addEventListener('click',e=>{if(e.target===box)box.close()});
 let touchX=0;[main,zoom].forEach(img=>{img.addEventListener('touchstart',e=>touchX=e.changedTouches[0].clientX,{passive:true});img.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-touchX;if(Math.abs(dx)>45)show(index+(dx<0?1:-1))},{passive:true})});
 root.querySelectorAll('.pd-option input').forEach(r=>r.addEventListener('change',()=>{filterGallery(r.dataset.gallerySide);root.querySelector('[data-pd-price]').textContent=r.dataset.price;root.querySelector('[data-pd-mobile-price]').textContent=r.dataset.price;root.querySelectorAll('[data-pd-add]').forEach(b=>{b.disabled=r.dataset.available!=='true';b.textContent=b.disabled?b.dataset.out:b.dataset.add});const stock=root.querySelector('[data-pd-stock]');stock.textContent=r.dataset.available!=='true'?root.dataset.outLabel:(r.dataset.tracked==='true'?(Number(r.dataset.stock)>0?'● '+root.dataset.stockLabel:root.dataset.outLabel):root.dataset.orderLabel);if(r.dataset.image){const i=thumbs.findIndex(t=>t.dataset.pdImage===r.dataset.image);if(i>=0)show(i);else{displayImage(r.dataset.image)}}const u=new URL(location.href);u.searchParams.set('variant',r.value);history.replaceState({},'',u)}));
 const desc=root.querySelector('[data-pd-description]'),specPanel=root.querySelector('#pd-spec'),docPanel=root.querySelector('[data-pd-documents]');
 const spec=desc.querySelector('.cp-technical'),docs=desc.querySelector('.cp-document-links');
 if(spec)specPanel.append(spec);else desc.querySelectorAll('table').forEach(table=>{const h=table.previousElementSibling;if(h&&/^H[2-4]$/.test(h.tagName))specPanel.append(h);specPanel.append(table)});
 if(specPanel.querySelector('table'))specPanel.querySelector('.pd-spec-fallback').remove();
 if(docs)docPanel.append(docs);
 const rows=[...specPanel.querySelectorAll('tr')].filter(r=>r.children.length>=2),map=JSON.parse(root.querySelector('[data-pd-map]').textContent);
 function fact(i,parent){const r=rows[i];if(!r)return;const d=document.createElement('div'),v=document.createElement('b'),label=document.createElement('span');v.textContent=r.children[1].textContent.trim();label.textContent=r.children[0].textContent.trim();if(parent.hasAttribute('data-pd-facts')&&map.water!==null){label.title=label.textContent;if(i===map.water)label.textContent=root.dataset.waterLabel;if(i===map.room)label.textContent=root.dataset.roomLabel;}d.append(v,label);parent.append(d)}
 map.facts.forEach(i=>fact(i,root.querySelector('[data-pd-facts]')));root.querySelector('[data-pd-facts]').hidden=!root.querySelector('[data-pd-facts]').children.length;map.fit.forEach(i=>fact(i,root.querySelector('[data-pd-fit]')));
 const editorialSummary=root.querySelector('[data-pd-editorial]');
 if(editorialSummary){
  const target=root.querySelector('[data-pd-highlights]');
  [...new Set([...map.facts,...map.fit])].slice(0,7).forEach(i=>fact(i,target));
  target.hidden=!target.children.length;
  root.querySelector('[data-pd-efficiency-note]').hidden=!rows.some(r=>/%/.test(r.children[1].textContent)&&/efficien|wirkungsgrad|rendement|rendimento|rendimiento|eficiencia|efici[eê]ncia|verkningsgrad/i.test(r.children[0].textContent));
  root.querySelector('.pd-more[open]').open=false;
 } else {
 const intro=desc.querySelector('p');if(intro){const lead=root.querySelector('[data-pd-intro]');lead.textContent=intro.textContent;lead.hidden=false;root.querySelector('[data-pd-summary]').append(intro.cloneNode(true))}
 const story=desc.querySelector('.cn-rich-description')||desc;
 const firstHeading=story.querySelector('h3,h2');if(firstHeading){root.querySelector('[data-pd-summary]').append(firstHeading.cloneNode(true));let n=firstHeading.nextElementSibling,count=0;while(n&&n.tagName==='P'&&count<2){root.querySelector('[data-pd-summary]').append(n.cloneNode(true));n=n.nextElementSibling;count++}}
 if(intro||firstHeading)root.querySelector('.pd-more').open=false;
 }
 thumbs.forEach((t,n)=>t.setAttribute('aria-current',String(n===index)));
 const tabs=[...root.querySelectorAll('[role=tab]')];function activate(t){tabs.forEach(b=>{const selected=b===t;b.setAttribute('aria-selected',String(selected));b.tabIndex=selected?0:-1;root.querySelector('#'+b.getAttribute('aria-controls')).hidden=!selected})}tabs.forEach((t,i)=>{t.addEventListener('click',()=>activate(t));t.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();activate(tabs[n]);tabs[n].focus()})});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ffh-compare"]) return;
  try {
    
document.querySelectorAll('[data-pc]').forEach(root=>{
 const main=root.querySelector('.pc-main-image'),thumbs=[...root.querySelectorAll('[data-pc-image]')],box=root.querySelector('dialog'),zoom=box.querySelector('img');let index=Math.max(0,thumbs.findIndex(t=>new URL(t.dataset.pcImage,location.href).pathname===new URL(main.src,location.href).pathname));
 const show=(i)=>{index=(i+thumbs.length)%thumbs.length;const src=thumbs[index].dataset.pcImage;main.removeAttribute('srcset');main.src=src;zoom.src=src;thumbs.forEach((t,n)=>t.setAttribute('aria-current',String(n===index)));box.querySelector('.pc-counter').textContent=`${index+1} / ${thumbs.length}`;};
 thumbs.forEach((t,i)=>t.addEventListener('click',()=>show(i)));
 root.querySelector('.pc-open').addEventListener('click',()=>{show(index);box.showModal()});box.querySelector('.pc-close').addEventListener('click',()=>box.close());box.querySelector('.pc-next').addEventListener('click',()=>show(index+1));box.querySelector('.pc-prev').addEventListener('click',()=>show(index-1));box.addEventListener('keydown',e=>{if(e.key==='ArrowRight')show(index+1);if(e.key==='ArrowLeft')show(index-1)});box.addEventListener('click',e=>{if(e.target===box)box.close()});
 let touchX=0;[main,zoom].forEach(img=>{img.addEventListener('touchstart',e=>touchX=e.changedTouches[0].clientX,{passive:true});img.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-touchX;if(Math.abs(dx)>45)show(index+(dx<0?1:-1))},{passive:true})});
 root.querySelectorAll('.pc-option input').forEach(r=>r.addEventListener('change',()=>{root.querySelector('[data-pc-price]').textContent=r.dataset.price;root.querySelector('[data-pc-mobile-price]').textContent=r.dataset.price;root.querySelectorAll('[data-pc-add]').forEach(b=>{b.disabled=r.dataset.available!=='true';b.textContent=b.disabled?b.dataset.out:b.dataset.add});root.querySelector('[data-pc-stock]').textContent=r.dataset.stockLabel;if(r.dataset.image){const i=thumbs.findIndex(t=>t.dataset.pcImage===r.dataset.image);if(i>=0)show(i);else{main.removeAttribute('srcset');main.src=r.dataset.image;zoom.src=r.dataset.image}}const u=new URL(location.href);u.searchParams.set('variant',r.value);history.replaceState({},'',u)}));
 const desc=root.querySelector('[data-pc-description]');const spec=desc.querySelector('.cp-technical'),docs=desc.querySelector('.cp-document-links');if(spec)root.querySelector('#pc-spec').append(spec);if(docs)root.querySelector('#pc-doc').append(docs);
 const tabs=[...root.querySelectorAll('[role=tab]')];function activate(t){tabs.forEach(b=>{const selected=b===t;b.setAttribute('aria-selected',String(selected));b.tabIndex=selected?0:-1;root.querySelector('#'+b.getAttribute('aria-controls')).hidden=!selected})}tabs.forEach((t,i)=>{t.addEventListener('click',()=>activate(t));t.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();activate(tabs[n]);tabs[n].focus()})});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ffh-header"]) return;
  try {
    
if(!customElements.get('ffh-navigation'))customElements.define('ffh-navigation',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const menu=this.querySelector('.fh-menu'),nav=this.querySelector('.fh-nav'),details=[...this.querySelectorAll('details')];this.close=()=>{details.forEach(d=>d.open=false);nav.classList.remove('is-open');menu.setAttribute('aria-expanded','false')};menu.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')!=='true';menu.setAttribute('aria-expanded',String(open));nav.classList.toggle('is-open',open);if(open)this.classList.remove('is-compact')});details.forEach(d=>d.addEventListener('toggle',()=>{if(d.open)details.forEach(other=>{if(other!==d)other.open=false})}));this.outside=e=>{if(!this.contains(e.target))this.close()};document.addEventListener('click',this.outside);this.addEventListener('keydown',e=>{if(e.key==='Escape'){const opened=details.find(d=>d.open);if(opened){opened.open=false;opened.querySelector('summary').focus()}else{this.close();menu.focus()}}});this.scroll=()=>{if(window.scrollY>240&&!this.contains(document.activeElement)&&!details.some(d=>d.open))this.classList.add('is-compact');else if(window.scrollY<120)this.classList.remove('is-compact')};window.addEventListener('scroll',this.scroll,{passive:true});this.scroll()}
disconnectedCallback(){document.removeEventListener('click',this.outside);window.removeEventListener('scroll',this.scroll);this.ready=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ffh-home"] && !Shopify.designMode) return;
  try {
    (() => {

  'use strict';

  const hero = document.querySelector('.hero');

  if (!hero) return;

  const slides = [...hero.querySelectorAll('.slide')];

  const dots = [...hero.querySelectorAll('[data-slide]')];

  const pause = document.querySelector('#pause');

  const status = document.querySelector('#slide-status');

  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  let index = 0, userPaused = motion.matches, hovered = false, timer = null, touchStart = null;

  const interval = 6500;

  function stopTimer() { clearTimeout(timer); timer = null; }

  function schedule() {

    stopTimer();

    if (!userPaused && !hovered && !document.hidden) timer = setTimeout(() => show(index + 1, false), interval);

  }

  function updatePause() {

    pause.setAttribute('aria-label', userPaused ? hero.dataset.play : hero.dataset.pause);

    pause.textContent = userPaused ? hero.dataset.play : hero.dataset.pause;

  }

  function loadSlide(slide) {
    const img = slide.querySelector('img');
    if (img.dataset.src) {
      img.loading = 'eager';
      if (img.dataset.srcset) { img.srcset = img.dataset.srcset; delete img.dataset.srcset; }
      img.src = img.dataset.src; delete img.dataset.src;
    }
  }

  function show(next, manual = true) {

    if (manual) { userPaused = true; updatePause(); }

    index = (next + slides.length) % slides.length;

    slides.forEach((slide, i) => {

      const active = i === index;
      if (active) loadSlide(slide);

      slide.classList.toggle('is-active', active);

      slide.setAttribute('aria-hidden', String(!active));

      slide.inert = !active;

      if (active) dots[i].setAttribute('aria-current', 'true');

      else dots[i].removeAttribute('aria-current');

    });

    hero.querySelector('.counter').textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;

    if (slides[index].querySelector('img').complete) loadSlide(slides[(index + 1) % slides.length]);
    if (manual) status.textContent = slides[index].getAttribute('aria-label');

    schedule();

  }

  document.querySelector('#previous').addEventListener('click', () => show(index - 1));

  document.querySelector('#next').addEventListener('click', () => show(index + 1));

  dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));

  pause.addEventListener('click', () => { userPaused = !userPaused; updatePause(); schedule(); });

  hero.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; stopTimer(); } });

  hero.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hovered = false; schedule(); } });

  hero.addEventListener('focusin', event => {

    if (event.target === pause) return;

    userPaused = true; updatePause(); stopTimer();

  });

  hero.addEventListener('keydown', event => {

    if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }

    if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }

  });

  hero.addEventListener('pointerdown', event => {

    if (event.pointerType === 'touch') touchStart = { x: event.clientX, y: event.clientY };

  });

  hero.addEventListener('pointerup', event => {

    if (!touchStart) return;

    const dx = event.clientX - touchStart.x, dy = event.clientY - touchStart.y;

    touchStart = null;

    if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1));

  });

  hero.addEventListener('pointercancel', () => { touchStart = null; });

  document.addEventListener('visibilitychange', schedule);

  motion.addEventListener('change', () => { if (motion.matches) { userPaused = true; updatePause(); stopTimer(); } });

  hero.querySelector('.carousel-controls').hidden = false;

  updatePause();

  show(0, false);

  const firstImage = slides[0].querySelector('img');
  const ready = () => { loadSlide(slides[1]); schedule(); };
  if (firstImage.complete) ready(); else {
    firstImage.addEventListener('load', ready, { once: true });
    firstImage.addEventListener('error', ready, { once: true });
  }

})();



(() => {

 const section = document.querySelector('.ffh-bestsellers'); if (!section) return;

 const track = section.querySelector('.ffh-best-track'), group = section.querySelector('.ffh-best-group');

 const toggle = section.querySelector('.ffh-best-toggle'), prev = section.querySelector('.ffh-best-prev'), next = section.querySelector('.ffh-best-next');

 const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

 let position = 0, width = 0, paused = false, hovered = false, last = 0, tween = null;

 function measure() { width = group.getBoundingClientRect().width; }

 function paint() { if (!width) return; position = ((position % width) + width) % width; track.style.transform = 'translate3d(' + (-position) + 'px,0,0)'; }

 function move(direction) {

  measure(); const card = group.querySelector('.ffh-best-card'); if (!card || !width) return;

  const distance = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(group).gap) || 20);

  tween = {distance: direction * distance, applied: 0, start: performance.now(), duration: motion.matches ? 0 : 420};

 }

 prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));

 toggle.addEventListener('click', () => { paused = !paused; toggle.setAttribute('aria-pressed', String(paused)); toggle.textContent = paused ? toggle.dataset.play : toggle.dataset.pause; });

 section.addEventListener('pointerenter', e => { if (e.pointerType !== 'touch') hovered = true; });

 section.addEventListener('pointerleave', () => { hovered = false; });

 function frame(now) {

  if (!section.isConnected) return;

  const delta = last ? Math.min(now-last,50) : 0; last = now;

  if (tween) {

   const progress = tween.duration ? Math.min((now-tween.start)/tween.duration,1) : 1;

   const eased = progress * progress * (3-2*progress), amount = tween.distance * eased;

   position += amount-tween.applied; tween.applied = amount; if (progress===1) tween=null;

  } else if (!paused && !hovered && !motion.matches && !document.hidden && !section.contains(document.activeElement)) { position += delta * 0.027; }

  paint(); requestAnimationFrame(frame);

 }

 measure(); new ResizeObserver(measure).observe(group); requestAnimationFrame(frame);

})();




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ffh-product"]) return;
  try {
    document.querySelectorAll('[data-gallery-image]').forEach(link=>link.addEventListener('click',e=>{e.preventDefault();const image=document.querySelector('#product-image');if(!image)return;image.removeAttribute('srcset');image.src=link.dataset.galleryImage;image.alt=link.dataset.imageAlt;document.querySelectorAll('[data-gallery-image]').forEach(a=>a.removeAttribute('aria-current'));link.setAttribute('aria-current','true');}));document.querySelector('#variant')?.addEventListener('change',e=>{const o=e.target.selectedOptions[0],b=document.querySelector('#add-to-cart');b.disabled=o.dataset.available!=='true';b.textContent=b.disabled?b.dataset.unavailable:b.dataset.add;document.querySelector('#variant-price').textContent=o.dataset.price;const image=document.querySelector('#product-image');if(o.dataset.image&&image){image.removeAttribute('srcset');image.src=o.dataset.image;}const u=new URL(location.href);u.searchParams.set('variant',o.value);history.replaceState({},'',u);});
  } catch(e) { console.error(e); }
})();
})();
